/* eslint-disable camelcase */
import { ALEFUSER_STORAGE_KEY } from './constants'

type AlefUser = {
  token: {
    access_token: string
  }
  user: {
    email: string
    enabled: boolean
    firstName: string
    id: number
    journey: string
    lastName: string
    membershipsV2: string[]
    name: string
    role: string
    roles: string[]
    tenant: string
    username: string
    uuid: string
    [key: string]: string | number | string[] | number[] | boolean
  }
}
const getAlefUserFromLocalStorage = (): AlefUser | null => {
  const alefUser = localStorage.getItem(ALEFUSER_STORAGE_KEY)
  if (!alefUser) {
    console.error('Access token missing')
    return null
  }
  return JSON.parse(alefUser)
}

export const getAlefUser = () => getAlefUserFromLocalStorage()

export const getAlefUserEmail = () => {
  const user = getAlefUserFromLocalStorage()
  return user && user.user && user.user.email ? user.user.email : ''
}

export const getAccessToken = () => {
  const token = getAlefUserFromLocalStorage()
  return token ? token.token.access_token : ''
}
